objectUtil = require("../util/object_util.coffee")
consts = require("../consts.coffee")


# need to get the ids of companies, jobs, posts, and coaches for bs
MODEL_ID_PROP_NAMES = ["job_id", "company_id", "post_id", "coach_id"]
MODEL_ID_TO_TYPE = {
    "company_id": "companies",
    "job_id": "jobs",
    "post_id": "posts",
    "coach_id": "coaches"
}

track = (eventName, eventProps={}, cb) ->
    eventProps = objectUtil.copyObject(eventProps)
    cbCalled = false
    cbExists = true
    timeoutId = null
    bsFailed = false

    # do some checks around the cb that was passed
    if not cb
        cbExists = false
    else if typeof cb != "function"
        console.error("muse.track was passed a cb that isn't a function")
        cbExists = false

    # add the referring page property to every event
    eventProps.page_referrer = document.referrer
    # add the query string property to every event
    eventProps.query_string = window.location.search
    # add path propery to every event if it does not already exist
    if not eventProps.path then eventProps.path = window.location.pathname

    eventProps.experiments = []
    eventProps.experiment_arms = []

    # create a new callback so that the call back can only be called once bec
    # there are multiple entry points to this function
    newCb = () ->
        # clear the timeout in case it exists so we reduce the possiblity of
        # `newCb` being called as we're invoking `cb`
        clearTimeout(timeoutId)
        if cbCalled or not cbExists then return

        cbCalled = true
        cb()

    # add experiment data to all logged events
    for experimentName, experimentArm of muse.experiments
        eventProps.experiments.push(experimentName)
        eventProps.experiment_arms.push("#{experimentName}_#{experimentArm}")

    # if phantomjs or headless tests we fire the cb right away and skip the tracking
    if consts.isHeadlessBrowser
        newCb()
        return

    try
        if window.OskarTS
            OskarTS.capture(eventName, eventProps)
    catch e
        console.error('OskarTS error', e)
        if window.newrelic then window.newrelic.noticeError(e)

    try
        if window.dataLayer
            dataLayer.push({event: eventName})
    catch e
        console.error('GoogleTagManager error', e)
        if window.newrelic then window.newrelic.noticeError(e)

    # if not cb exists we don't need to worry about the rest of the logic
    if not cbExists
        return

    newCb()

module.exports = track



// WEBPACK FOOTER //
// ./node_modules/musecoreui/tracking/muse_track.coffee